export function isCanceledError(e: any): e is CanceledError {
  return e?.isCancelError === true;
}

self.addEventListener('error', e => {
  return isCanceledError(e.error);
});

export default class CanceledError extends Error {
  isCancelError = true;

  constructor(message?: string) {
    super(message ?? 'Canceled');
  }
}
